export const bannedWords = [
	"anal",
	"anilingus",
	"anus",
	"asshole",
	"asswhore",
	"asswhores",
	"asswipe",
	"asswipes",
	"autofellatio",
	"blowjob",
	"bulldyke",
	"chink",
	"chinks",
	"chinky",
	"clit",
	"cocksucker",
	"cocksuckers",
	"cocksucking",
	"cum",
	"cunnilinction",
	"cunnilinctor",
	"cunnilinctors",
	"cunnilinctus",
	"cunnilingual",
	"cunnilinguism",
	"cunnilinguist",
	"cunnilinguistic",
	"cunnilinguists",
	"cunnilingus",
	"cunny",
	"cunt",
	"cunts",
	"cunty",
	"deepthroat",
	"deepthroating",
	"dick",
	"dildo",
	"fag",
	"fagged",
	"fagging",
	"faggot",
	"faggoted",
	"faggoting",
	"faggotings",
	"faggotries",
	"faggotry",
	"faggots",
	"faggoty",
	"faggy",
	"fagin",
	"fagins",
	"fagot",
	"fagoted",
	"fagoter",
	"fagoters",
	"fagoting",
	"fagotings",
	"fagots",
	"fags",
	"fellatio",
	"fellation",
	"fellatios",
	"fellator",
	"fellators",
	"fellatrice",
	"fellatrices",
	"fellatrix",
	"fuck",
	"fuckbuddy",
	"fucked",
	"fucker",
	"fuckers",
	"fuckhead",
	"fucking",
	"fucks",
	"fuckup",
	"fuckups",
	"gyp",
	"gypo",
	"gyps",
	"gypsy",
	"handjob",
	"horny",
	"jigaboo",
	"kerchoo",
	"kike",
	"kikes",
	"kink",
	"kinkily",
	"kinks",
	"kinky",
	"kkk",
	"kkker",
	"kkkers",
	"knacker",
	"knackers",
	"kyke",
	"milf",
	"motherfucker",
	"motherfuckers",
	"motherfucking",
	"nazi",
	"nazification",
	"nazifications",
	"nazified",
	"nazifies",
	"nazify",
	"nazifying",
	"nazis",
	"nigged",
	"nigger",
	"niggers",
	"niggle",
	"niggled",
	"niggler",
	"nigglers",
	"niggles",
	"pussy",
	"slut",
	"sluts",
	"sluttier",
	"sluttiest",
	"sluttish",
	"sluttishly",
	"sluttishness",
	"sluttishnesses",
	"slutty",
	"sodomy",
	"syph",
	"syphs",
	"tits",
	"titty",
	"turdlicker",
	"twat",
	"ziggaboo",
];
